<template>
    <v-card class="purchase-method-item" v-bind="props_card" @click="emit(item.value)">
        <v-row no-gutters align="center">
            <v-col cols="auto">
                <v-card-title class="purchase-method-item__name">
                    <v-icon>{{ icon }}</v-icon>
                    {{ item.text }}
                </v-card-title>
            </v-col>
            <v-spacer />
            <v-col cols="12" sm="auto">
                <v-card-text class="purchase-method-item__text">
                    <div v-html="item.desc" />
                </v-card-text>
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
/** @typedef {import('@/store/nshop').NshopOrder_Payment_Method} NshopOrder_Payment_Method */
export default {
    props: {
        /** @type {import('vue').PropType<NshopOrder_Payment_Method>} */
        value: { type: String, default: "vaccount" },
        item: { type: Object, default: () => ({}) },
    },
    computed: {
        active() {
            return this.value == this.item.value;
        },
        icon() {
            if (this.active) return "mdi-check-circle-outline";
            return "mdi-circle-outline";
        },
        props_card() {
            let props = {
                rounded: true,
                elevation: 0,
            };

            if (this.active) {
                props.color = "primary";
                props.dark = true;
            }

            return props;
        },
    },
    methods: {
        emit() {
            this.$emit("input", this.item.value);
        },
    },
};
</script>

<style lang="scss" scoped>
.purchase-method-item {
    overflow: hidden;

    &__name {
        display: flex;
        gap: 8px;
    }
    &__text {
        padding-top: 0;
        white-space: pre-line;
        @media screen and (min-width: 576px) {
            padding-bottom: 0;
            text-align: end;
        }
    }
}
</style>
